import {ACCESS_TOKEN,  USER_ID, USER_NAME, TEAM_ID, TEAM_NAME} from "@/common/Constant";

function setLocalStorage( name:string , data:string ):void{
    if( localStorage != null ){
        localStorage.setItem(name, data)
    }
}

function getLocalStorage( name:string ):string|null{
    let value:string | null = ""
    if( localStorage != null ){
         value = localStorage.getItem(name)
    }
    return value
}

function initStorage(){
    localStorage.setItem(ACCESS_TOKEN, '')
    localStorage.setItem(USER_ID, '')
    localStorage.setItem(USER_NAME, '')
    localStorage.setItem(TEAM_ID, '')
    localStorage.setItem(TEAM_NAME, '')
}


export default {
    setLocalStorage,
    getLocalStorage,
    initStorage
}